const InputTextField = ({
  labelName = "",
  name = "",
  register,
  id = "",
  type = "text",
  errors,
  errorText = "",
  placeholder = "",
  inputValue = "",
  isRequired = true,
  className = "",
  disable = false,
  isReadOnly = false,
  onInput = () => {},
  view = false,
}) => {
  return (
    <>
      <label className="form-label title mb-2" htmlFor={id}>
        {labelName}{" "}
        {isRequired && !isReadOnly ? <span className="star">*</span> : null}
      </label>
      {isReadOnly ? (
        <input
          value={inputValue}
          type={type}
          className={`form-control w-75 ${className}`}
          disabled={true}
        />
      ) : (
        <>
          <input
            className={`form-control w-75 ${className}`}
            type={type}
            name={name}
            id={id}
            {...register(name, { required: isRequired })}
            placeholder={placeholder}
            disabled={view}
            // onInput={onInput}
            onInput={(e) => {
              if (name === "pincode") {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 6);
              }
              onInput?.(e);
            }}
          />
          {errors[name] && (
            <div className={`invalid-feedback d-block`}>{errorText}</div>
          )}
        </>
      )}
    </>
  );
};

export default InputTextField;
